declare global {
  interface Window {
    profitwell:
      | ((type: string, data: Record<string, unknown>) => void)
      | undefined
  }
}

export const setProfitwell = (email: string) => {
  if (!window.profitwell) {
    console.error('The ProfitWell script could not be found.')
    return
  }

  window.profitwell('start', { user_email: email })
}
